import React from 'react'

const DraftModalSkeleton = (props) => {
    const {translations} = props
    return (
        <div className="grid md:grid-cols-2 gap-4 md:divide-x-[1px] max-md:divide-y-[1px] divide-lightGray">
            <div>
                <h3 className="text-xl font-bold mb-2">{translations?.draft}</h3>
                <div className="aspect-square bg-lightGray/50">
                    <div className="w-full h-full bg-gray animate-pulse"></div>
                </div>
                <div className="flex items-center justify-between mt-3">
                    <span className="w-40 h-6 rounded bg-gray animate-pulse"></span>
                </div>
                <div className='mt-3 w-full h-12 rounded bg-gray animate-pulse'></div>
            </div>
            <div className="md:pl-4 max-md:pt-4 flex flex-col">
                <h3 className="text-xl font-bold mb-5">{translations?.allComments}</h3>
                <div className="overflow-y-auto flex-1">
                    <div className="flex items-start gap-2.5 mb-4">
                        <div className="min-w-12 h-12 aspect-square bg-gray rounded-full overflow-hidden">
                            <div className="w-full h-full bg-gray animate-pulse"></div>
                        </div>
                        <div className="">
                            <h3 className="w-48 h-7 bg-gray rounded animate-pulse"></h3>
                            <span className="w-36 h-3 bg-gray rounded animate-pulse"></span>
                            <p className="mt-2 w-full h-5 bg-gray rounded animate-pulse"></p>
                        </div>
                    </div>
                </div>
                <div className="border border-lightGray rounded p-2.5 flex items-end gap-1.5 mt-5">
                    <div className="w-full h-16 bg-gray animate-pulse rounded"></div>
                </div>
            </div>
        </div>
    )
}

export default DraftModalSkeleton
